import React from 'react';

const Title = ({ title, variant }) => {
  return (
    <div className={`title-container ${variant} `}>
        <div className="title ">
            <p className="title-background" aria-hidden="true" role="presentation">{title}</p>
            <h1 className="content">{title}</h1> 
        </div>
    </div>
  );
};

export default Title;